// The sentence that carries a link to the open calendar to a patient.
//
// The link's whole purpose is to be sent, and the message box sits directly
// below the button that makes one. Leaving the office to copy a URL out of a
// field and paste it into that box is work the software should have done.
// The wording itself is in offerMessage.ts.
import { openLinkText } from './offerMessage';
import { getPracticeTimeZone } from '../../utils/practiceTime';

/** What the link is for and when it stops — all optional; what is unknown is left unsaid. */
export interface InviteAbout {
  service?: string | null;
  provider?: string | null;
  expiresAt?: string | Date | null;
  timeZone?: string;
}

/**
 * @param greet false when the message already opens with a greeting — appending
 *   a second "Hi Jane" underneath the one they typed reads like a form letter.
 */
export function bookingInviteLine(patientName: string, url: string, greet: boolean = true, about: InviteAbout = {}): string {
  return openLinkText({
    patientName, url, greet,
    service: about.service, provider: about.provider, expiresAt: about.expiresAt,
    timeZone: about.timeZone || getPracticeTimeZone(),
  });
}

// Appends rather than replaces, which is the opposite of how the slot list
// behaves and is right for both: a list of times replaces a list of times, but
// a link is something you add to whatever you were already saying.
export function withInvite(draft: string, url: string, patientName: string, about: InviteAbout = {}): string {
  const existing = String(draft || '').trim();

  // Nothing written yet, so this is the whole message and has to greet.
  if (!existing) return bookingInviteLine(patientName, url, true, about);

  // Pressing the button twice, or making a second link, should not stack up
  // invitations in the box.
  if (existing.includes(url)) return existing;

  return `${existing}\n\n${bookingInviteLine(patientName, url, false, about)}`;
}
